module.exports = __webpack_public_path__ + "img/07_shimizu_01.3a611549.jpg";